import { dehydrate, QueryClient, useQuery } from "@tanstack/react-query";
import { fetchQueryFunction } from "./queries";
import { Media } from "./Media";

export type Platform = {
  id: number;
  name: string;
  slug: string;
  contact_email?: string;
  publish_status?: string;
  description?: string;
  subtitle?: string;
  timezone?: string;
  links: { key: string; value: string }[];
  terms: Record<string, string>;
  logo?: Media;
};

export const fetchPlatform = () =>
  fetchQueryFunction<void, Platform>({
    path: "platform",
    resource: "platform",
  });

export const useCurrentPlatform = () =>
  useQuery<Platform, Error>({
    queryKey: ["platform"],
    queryFn: () => fetchPlatform(),
  });

export const prefetchPlatform = async () => {
  const queryClient = new QueryClient();
  await queryClient.prefetchQuery({
    queryKey: ["platform"],
    queryFn: fetchPlatform,
  });
  return dehydrate(queryClient);
};
